import { combineReducers } from "redux";
import sidebar from './sidebar';
import modal from './modal';
export default combineReducers({ 
  sidebar,
  modal
});